export default __webpack_public_path__ + "static/media/whatsapp.4dc47624.svg";